/**
 * ChartViewResetChip — tiny visible "RESET ZOOM" pill that appears above a
 * native-SVG chart when the user has zoomed away from the base view.
 *
 * Used by charts that don't already render <ChartTimeRangeRow> (which has
 * its own reset button) — Histogram, Q-Q, DataExplorer, etc. — so users
 * always have a discoverable escape from a zoomed state, not just dblclick.
 */

interface Props {
  isZoomed: boolean;
  onReset: () => void;
}

export function ChartViewResetChip({ isZoomed, onReset }: Props) {
  if (!isZoomed) return null;
  return (
    <div className="flex items-center gap-2 mb-2 text-[10px]" style={{ color: 'var(--dv-text-muted)' }}>
      <span style={{ letterSpacing: '0.05em' }}>ZOOMED</span>
      <button
        type="button"
        onClick={onReset}
        className="px-2 py-0.5 rounded text-[10px] tracking-wider transition-colors"
        style={{
          color: 'var(--dv-text-muted)',
          border: '1px solid var(--dv-border-subtle)',
          cursor: 'pointer',
          fontVariantNumeric: 'tabular-nums',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = 'var(--dv-text-primary)';
          e.currentTarget.style.background = 'var(--dv-bg-card-hover)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = 'var(--dv-text-muted)';
          e.currentTarget.style.background = 'transparent';
        }}
        title="Reset zoom (or double-click chart)"
      >
        RESET
      </button>
      <span style={{ opacity: 0.7 }}>· Shift+drag = 2D zoom · Ctrl+drag = pan · Ctrl+wheel = zoom · dblclick = reset</span>
    </div>
  );
}
